export default url => {
	// wp accepted video types https://wordpress.com/support/accepted-filetypes/
	const videoExtensions = ['.mp4', '.m4v', '.mpg', '.mov', '.vtt', '.avi', '.ogv', '.wmv', '.3gp', '.3g2'];
	const fileExtension = url.slice(((url.lastIndexOf('.') - 1) >>> 0) + 2);
	return videoExtensions.includes(`.${fileExtension.toLowerCase()}`);
};
